import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { clientApi, setClientToken, getClientToken } from "../../lib/clientApi";
import { Lock, User, ArrowRight, ShieldCheck } from "lucide-react";

function formatError(detail) {
  if (detail == null) return "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AreaLogin() {
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  // already logged in?
  if (getClientToken()) {
    nav("/area-riservata/dashboard", { replace: true });
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!username.trim() || !code) {
      setErr("Inserisci nome utente e codice di accesso");
      return;
    }
    setLoading(true);
    try {
      const { data } = await clientApi.post("/client-auth/login", {
        username: username.trim().toLowerCase(),
        access_code: code,
      });
      setClientToken(data.token);
      nav("/area-riservata/dashboard", { replace: true });
    } catch (e2) {
      setErr(formatError(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16" data-testid="area-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#EAF8F0] text-[#007A3D] mb-4">
            <ShieldCheck className="w-7 h-7" />
          </div>
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#007A3D]">Area Riservata</span>
          <h1 className="mt-3 font-display font-black tracking-tighter text-3xl sm:text-4xl text-[#1A1A1A]">Accedi ai tuoi documenti</h1>
          <p className="mt-3 text-sm text-[#6B7280]">Inserisci le credenziali ricevute dallo studio.</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-3xl border border-[#E5E7EB] shadow-sm p-8 space-y-5">
          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.18em] text-[#1A1A1A] mb-2">Nome Utente</label>
            <div className="relative">
              <User className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#6B7280]" />
              <input
                data-testid="area-login-username"
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full rounded-xl border border-[#E5E7EB] pl-11 pr-4 py-3 text-sm focus:outline-none focus:border-[#00A651]"
                placeholder="mario.rossi"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.18em] text-[#1A1A1A] mb-2">Codice di Accesso</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#6B7280]" />
              <input
                data-testid="area-login-code"
                type="password"
                autoComplete="current-password"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="w-full rounded-xl border border-[#E5E7EB] pl-11 pr-4 py-3 text-sm focus:outline-none focus:border-[#00A651]"
                placeholder="••••••••"
              />
            </div>
          </div>
          {err && (
            <div data-testid="area-login-error" className="text-sm text-[#B91C1C] bg-[#FEF2F2] border border-[#FECACA] rounded-xl px-4 py-3">
              {err}
            </div>
          )}
          <button
            data-testid="area-login-submit"
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#00A651] hover:bg-[#007A3D] disabled:opacity-60 text-white rounded-full px-6 py-3.5 text-sm font-medium transition-colors shadow-lg shadow-[#00A651]/20"
          >
            {loading ? "Accesso in corso…" : <>Accedi <ArrowRight className="w-4 h-4" /></>}
          </button>
          <p className="text-center text-xs text-[#6B7280] mt-4">
            Hai dimenticato il codice di accesso?<br />
            Contatta lo studio Betelgez al <a href="tel:+393462461457" className="font-medium text-[#007A3D] hover:underline">+39 346 2461457</a>
          </p>
        </form>

        <div className="mt-6 text-center">
          <Link to="/" className="text-sm text-[#6B7280] hover:text-[#007A3D]">← Torna al sito</Link>
        </div>
      </div>
    </div>
  );
}
